// extracted by mini-css-extract-plugin
module.exports = {"container":"Details_container__1dJe9","face":"Details_face__2IamB","front":"Details_front__1eRgp","back":"Details_back__1mJkv"};